import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import { useBalance } from '../../../DataStore/BalanceContext';
import { useTheme } from '../../../DataStore/ThemeContext';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useAccounts } from '../../../DataStore/AccountsContext';

const reducer = (state, action)=>{
    if(action.type === "RESET"){
        return {...initialState}
    }
    return { ...state, [action.type]: action.value };
}

const initialState = {
    apiKey: '',
    username: '',
    password: '',
    cashAccount: '',
    loading: false,
}


const EditGateway = ({gateway}) => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const [info, setInfo] = useState('');
    const { getPaymentAccounts, paymentAccountListing } = useAccounts();
    const {closeSettings, setNotify, setSystemFunction} = useTheme();
    


    useEffect(()=>{
        getPaymentAccounts();
    }, [])

    useEffect(()=>{
        if(gateway){
            dispatch({type: 'apiKey', value: gateway.api_key});
            dispatch({type: 'username', value: gateway.username});
            dispatch({type: 'password', value: gateway.password});
            dispatch({type: 'cashAccount', value: {label: gateway.cash_account?.account_name, value: gateway.cash_account?.account_id}})
        }
    }, [gateway])

    useEffect(()=>{
          setSystemFunction(() => handleSave);
          return () => setSystemFunction(() => {});
        }, [state]);


    const handleSave=async()=>{
        setInfo('');
        dispatch({type: 'loading', value: true})
        const server_response = await ajaxConfig.updateGateway({
            collector_code: gateway.collector_code, 
            api_key: state.apiKey, 
            username: state.username, 
            password: state.password, 
            cash_account_id: state.cashAccount.value
        });
        dispatch({type: 'loading', value: false})
        if(server_response.status==="OK"){
            setNotify(<Notification type="success" message={server_response.message} closable={false}/>)
            gateway.onComplete();
            closeSettings();
        }else{
            setInfo(<Notification type="danger" message={server_response.message} closable={false}/>)
        }
    }

    const RenderCashAccount = () => {

        const options = [];
        if (Array.isArray(paymentAccountListing)) {
          paymentAccountListing.map((item, key) =>
            options.push({
              label: item.account_number + " " + item.account_name,
              value: item.account_id,
            })
          );
        }
        return (
          <TextInput
            label="Cash Account"
            type="select"
            leftIcon="fa fa-university"
            placeholder={"Select account to track gateway transactions..."}
            options={options}
            onChange={(item) => dispatch({type: 'cashAccount', value: item})}
            leftComponent={
              <i
                className="fa fa-university"
                onClick={() => getPaymentAccounts(true)}
              ></i>
            }
            loading={!paymentAccountListing}
            wrap
            value={state.cashAccount}
          />
        );
    };


    return (
        <>

        <CallOut 
            title="Payment Gateway"
            description={`Configure credentials for ${gateway?.collector_name}`}
         />
        <div className='mt-4'>{info}</div>
        <form method='post' onSubmit={handleSave}>
                <TextInput
                    type="text"
                    label="Username"
                    placeholder={`Enter username for ${gateway?.collector_name}`}
                    leftIcon="fa fa-user"
                    onChange={e => dispatch({type: 'username', value: e.target.value})}
                    value={state.username}
                    wrap
                    />

                <TextInput
                    type="password"
                    label="Password"
                    placeholder={`Enter password for ${gateway?.collector_name}`}
                    leftIcon="fa fa-unlock"
                    onChange={e => dispatch({type: 'password', value: e.target.value})}
                    value={state.password}
                    wrap
                    />

                <TextInput
                    type="text"
                    label="API Key"
                    placeholder={`Enter API Key for ${gateway?.collector_name}`}
                    leftIcon="fa fa-key"
                    onChange={e => dispatch({type: 'apiKey', value: e.target.value})}
                    value={state.apiKey}
                    wrap
                    />
        
                 {RenderCashAccount()}


        </form>
        </>
    );
};

export default EditGateway;